import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { getFormattedNumber } from '../../../../../../common/utils'

class QtRfTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: 'row',
      justify: 'center',
      alignItems: 'center'
    }
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes,
      job
    } = this.props;

    const { alignItems, direction, justify } = this.state
    let rfsummary = results && results.data && results.data.subtests
     && results.data.subtests.qualification && results.data.subtests.qualification.rfsummary
     && results.data.subtests.qualification.rfsummary ? results.data.subtests.qualification.rfsummary : null;
    let data = null;
    let worstmargin = null;
    if (rfsummary) {
      data = rfsummary.filter(item => { return (item.subtesttype == subtest); });
      worstmargin = data && data.length > 0 ? data[0].worstmargin : null;
    }

    if (worstmargin) {
      return (
        <Grid
          container
          spacing={0}
          justify='center'
          direction='row'
          alignItems='center'
          className={classes.RFsubtestContainer}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            alignContent='center'
          >
            <Grid item alignContent='center'>
            </Grid>
            <Grid
              container
              spacing={16}
              className={classes.demo}
              alignItems={alignItems}
              direction={direction}
              justify={justify}
            >
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                alignItems='flex-end'
              >
                <Typography className={classes.button}>
                  {translate('rfsubtest_margin')}
                </Typography>
                <Typography className={classes.title}>
                  {worstmargin.margin === undefined || worstmargin.margin === null ? '-' : getFormattedNumber(worstmargin.margin) + translate("dB")}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                alignItems='flex-start'
              >
                <Typography className={classes.button}>
                  {translate('rfsubtest_value')}
                </Typography>
                <Typography className={classes.title}>
                  {worstmargin.value === undefined || worstmargin.value === null ? '-' : getFormattedNumber(worstmargin.value) + translate("dB")}
                </Typography>

              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid container spacing={0}>
        <Grid xs={12} className={classes.topGrid}>
          <Typography className={classes.t_tar_text}>
            {subtest}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(QtRfTest);
